export type HourBankEntryType = 'CREDIT' | 'DEBIT';

export class UserHourBankModel {
    user_hour_bank_id: number;
    user_id: number;
    entry_date: string | Date;
    hours: number;
    entry_type: HourBankEntryType;
    observation: string | null;
    created_by_user_id: number | null;
    createdAt: Date;

    constructor(data?: Partial<UserHourBankModel>) {
        this.user_hour_bank_id = data?.user_hour_bank_id ?? null;
        this.user_id = data?.user_id ?? null;
        this.entry_date = data?.entry_date ?? null;
        this.hours = data?.hours != null ? Number(data.hours) : null;
        this.entry_type = data?.entry_type ?? null;
        this.observation = data?.observation ?? null;
        this.created_by_user_id = data?.created_by_user_id ?? null;
        this.createdAt = data?.createdAt ?? null;
    }
}
